import * as Namespaces from './namespaces'

const locales = {
	[Namespaces.USERS]: {
		el: {
			'Insert a positive number': 'Εισάγετε έναν θετικό αριθμό',
			'Insert a valid date': 'Εισάγετε μία έγκυρη ημερομηνία',
			'Enter a valid email': 'Εισάγετε ένα έγκυρο email',
			'All data related to this user will be deleted!': 'Όλα τα δεδομένα για αυτόν τον χρήστη θα διαγραφούν!',
			'Actions':'Ενέργειες',
			'Add' : 'Προσθήκη',
			'Name' : 'Ονομ/νυμο',
			'Father Name' : 'Όνομα Πατρός',
			'Username' : 'Όνομα χρήστη',
			'Email' : 'Email',
			'Origin' : 'Προέλευση',
			'Active' : 'Ενεργός',
			'Users' : 'Χρήστες',
			'Basics' : 'Βασικά',
			'Password' : 'Κωδικός',
			'Confirm Password' : 'Επαλήθευση Κωδικού',
			'Localization' : 'Προσαρμογή',
			'Language' : 'Γλώσσα',
			'User Create' : 'Δημιουργία Χρήστη',
			'User Edit' : 'Επεξεργασία Χρήστη',
			'User Details' : 'Λεπτομέρειες Χρήστη',
			'Return' : 'Επιστροφή',
			'Save' : 'Αποθήκευση',
			'Delete' : 'Διαγραφή',
			'Edit' : 'Επεξεργασία',
			'Details' : 'Λεπτομέρειες',
			'Tabs' : 'Καρτέλες',
			'Roles' : 'Ρόλοι',
			'Rights' : 'Δικαιώματα',
			'PasswordRestoration' : 'Ανάκτηση Κωδικού',
			'Users List' : 'Λίστα Χρηστών',
			'Right' : 'Δικαίωμα',
			'View Access' : 'Πρόσβαση Προβολής',
			'Edit Access' : 'Πρόσβαση Επεξεργασίας',
			'User created successfully!' : 'Ο χρήστης δημιουργήθηκε με επιτυχία!',
			'User updated successfully!' : 'Ο χρήστης ενημερώθηκε με επιτυχία!',
			'User deleted successfully!' : 'Ο χρήστης διαγράφηκε με επιτυχία!',
			'An error occurred!' : 'Παρουσιάστηκε σφάλμα!',
			'Please wait...' : 'Παρακαλώ περιμένετε...',
			'msg.login_notfound' : 'Λανθασμένα στοιχεία πρόσβασης',
			'Cancel' : 'Ακύρωση',
			'Confirm' : 'Επιβεβαίωση',
			'Last Login' : 'Τελευταία Σύνδεση',
			'Role' : 'Ρόλος',
			'Skills' : 'Ειδικότητα',
			'Workers' : 'Εργαζόμενοι',
			'Worker Details' : 'Λεπτομέρειες Εργαζόμενου',
			'Worker Edit' : 'Επεξεργασία Εργαζόμενου',
			'Worker Create' : 'Δημιουργία Εργαζόμενου',
			'Cost' : 'Κόστη',
			'Work Cost' : 'Κόστος εργασίας',
			'Extra Work Cost' : 'Υπερωριακό κόστος',
			'From Date' : 'Από ημ/νία',
			'To Date'  : 'Έως ημ/νία',
			'There is a record within this date range!' : 'Υπάρχει εγγραφή σε αυτό το εύρος ημερομηνιών!',
			'Required' : 'Απαιτείται',
			'Code' : 'Κωδικός',
			'Passwords must match' : 'Οι κωδικοί πρέπει να ταιριάζουν',
			'Password must be between 6-20 characters' : 'Ο κωδικός πρέπει να έχει 6-20 χαρακτήρες'
			
		},
		en: {
			'msg.login_notfound' : 'Incorrect Login Credentials',
			'User Create' : 'Create User',
			'User Edit' : 'Edit User',
		}
	},
}

export default locales